import React, {Component} from 'react';
import {Button, Table} from 'react-bootstrap';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';
import { translate } from 'react-i18next';
import Parser from 'html-react-parser';
import $ from 'jquery';
import { question } from 'react-icons-kit/icomoon/question';
import { Route } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import Loader from 'react-loader-spinner';
import VirtualKeyboard from './VirtualKeyboard';
const Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');

class Interview extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.ChangeSearchByFingerprint = this.ChangeSearchByFingerprint.bind(this);
        this.getQuestions = this.getQuestions.bind(this);
        this.onSave = this.onSave.bind(this);
        this.clear = this.clear.bind(this);
        this.getResponse = this.getResponse.bind(this);
        this.changeRadio = this.changeRadio.bind(this);
        this.onLast = this.onLast.bind(this);
        this.onNext = this.onNext.bind(this);
        this.validQuestion = this.validQuestion.bind(this);

        this.state = {
            no_offer:"",
            id:"",
            date:"",
            questions:[],
            questionary_id:"",
            disable:false,
            date_response:"",
            exclusion_by_questionnaire:{},
            index:0,
            name:"",
            interview_type:"",
            self_exclusion:"",
            searchByOffer:false,
            searchByFingerprint:true,
            flagStart:false,
            flagFinished:false,
            focusedInput: null,
            indexHelper:"",
            fieldName:"",
        }

    }

    componentDidMount(){
        if(this.props.location.pathname !== '/interview'){
            this.setState({disable: true});
        }

        fetch(Config.default.apiGateway.URL+'functional_criterion?code=EXCLUSION_BY_QUESTIONNAIRE',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
                exclusion_by_questionnaire: response,
                interview_type: response.value === 'YES' ? '' : "interview"
            });
            
		});

        /////
        //inicia huella en encuesta
        ////
        this.props.socket.onerror = (e)=>{
			this.setState({disableStartBtn:true});
		}

		this.props.socket.onopen = (e)=>{
			//socket.send("FPReset");
			this.props.socket.send("initfp");
			
		}

		this.props.socket.onmessage = (event)=>{
			var res = JSON.parse(event.data);
                console.log(res)
			if(res.MachineName){
		    	console.log(res.MachineName);
		    }

			if (res.Mensaje){
		        console.log(res.Mensaje);
			}

			if(res.Error){
				if(res.Error === "No hay lector inicializado"){
					swal("Error", "No hay lector inicializado. Por favor verifique la conexión de su dispositivo y refresque la pagina", 'error');
				}else{
					swal("Error", res.Error, 'error');
				}
			}

            if (res.Mensaje)
		        console.log(res.Mensaje);

		    if (res.Fmd) {
                //console.log(res.Fmd)
		    	this.setState({ flagFinished:true,searching:true});
		    	fetch(Config.default.apiGateway.backFinger+'fingerprint/searchencuesta?fingerprint='+res.Fmd, {
				 	method: 'GET', // or 'PUT'
				  	body: JSON.stringify(), // data can be `string` or {object}!
				  	headers: new Headers({
				  		'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				  		'Accept': 'application/json',
				  		'Content-Type': 'application/json;charset=UTF-8'
				  	})
				}).then(res => res.ok?res.json():this.setState({searching:false}))
				.catch(error => console.log('Error:', error))
				.then(response => {
					if(response !== undefined){
                        this.props.waiting.handleShow('Buscando...');
                        console.log(this.state.interview_type);
        fetch(Config.default.apiGateway.URL+'offers/check?offer_id='+response.offer.id+'&option='+(this.state.interview_type === 'interview' ? 'questionnaire' : 'self_exclusion'),{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(async response => {
            if(response !== undefined){
                await this.clear();
                
                await this.setState({
                    id:response.id,
                    name:response.donor_name,
                    date: moment(response.timestamp_date).format('DD/MM/YYYY')+' '+moment(response.timestamp_hour, 'HH:mm:ss.sssssss').format('HH:mm:ss')
                })

                swal({
                    title: "Alerta",
                    text: "Eres "+response.donor_name+"?",
                    type: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Si",
                    cancelButtonText: "No"
                    //customClass: "Custom_Cancel"
                }, async (isConfirm)=> {
                    if (isConfirm) {
                        this.getQuestions();

                        this.setState({flagStart:false})
                        if(this.state.exclusion_by_questionnaire.value === 'YES' && this.state.interview_type === 'autoexclusion'){
                            this.getMessage();
                        }
                    }else{
                        this.setState({flagStart:false})
                        await this.clear();
                        await this.setState({interview_type: this.state.exclusion_by_questionnaire.value === 'YES' ? 'autoexclusion' : "interview"});
                    }
                });

                
            }
        })
						//this.props.save(response);
                        //console.log("te")
                         //this.getRespuestaOffer(response.donor.id)
						//this.setState({show:false, formulario:true,searching:false,offer: response.offer, donor: response.donor,donation:response.donation,donation_type_extraction:response.donation_type_extraction,flagFinished:true,flagmensage:true});
                        //console.log("aqui "+ this.state.flagFinished);
					}
				});
		    	
		    }
        }
    }

    getMessage(){
        fetch(Config.default.apiGateway.URL+'html_templates/self_exclusion_message',{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Content-Type'  : 'application/json',
                'Accept'        : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg, 'error');
                })
            }
        }).then(response => {
            if(response !== undefined){
                var msg = JSON.parse(response);                
                setTimeout(()=>{                    
                    swal({
                        title: '',
                        type: 'info',
                        html:true,
                        text:'<div>'+
                            msg[0]+
                        '</div>',
                    });
                }, 500)
                
            }
        })
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    changeRadio(e){
        var questions = this.state.questions;
        var value = e.target.value;        
        var id = e.target.name.split('-')[0] === 'self_exclusion' ?
                    e.target.name.split('-')[0]
                : parseInt(e.target.name.split('-')[0]);
        var index_row = parseInt(e.target.name.split('-')[1]);
        var index_section = e.target.name.split('-')[2] === undefined || e.target.name.split('-')[2] === "" ?
                                "" 
                            : parseInt(e.target.name.split('-')[2]);
        var index_option = e.target.name.split('-')[3] === undefined || e.target.name.split('-')[3] === "" ? 
                                "" 
                            : parseInt(e.target.name.split('-')[3]);
        var index = questions.findIndex(obj => obj.ask_id === id);            
    
        if(index !== -1){
            if(questions[index].value !== undefined){
                questions[index].value = value;
            }
            

            if(index_option !== ""){
                questions[index].rows[index_row].sections[index_section].value = value;
                questions[index].rows[index_row].sections[index_section].sections.map((section, j)=>
                    j === index_option ?
                        section.checked = true
                    :
                        section.checked = false                    
                );
            }else{
                if(index_section !== ""){
                    questions[index].rows[index_row].sections[index_section].value = value;
                }else{
                    
                    questions[index].rows[index_row].value = value;
                    
                    
                    if(questions[index].rows[index_row].type === undefined){
                        questions[index].rows.map((row, i)=>{
                            i === index_row ?                                    
                                row.checked = true
                            :
                                row.checked = false   
                        });
                    }
                }
                
            }                
        }

        if(id === 'self_exclusion'){
            this.setState({
                [id]: value === 'NO' ? false : true
            });
        }

        this.setState({questions: questions});
    
        
        if(e.target.type === 'radio'){
            //this.onNext();
        }
        
    }

ChangeSearchByFingerprint(){
        this.setState({searchByFingerprint:true,searchByOffer:false,flagFinished:false,flagStart:false});
}
ChangeSearchByOffer(){
    this.setState({searchByFingerprint:false,searchByOffer:true})
}
    onSearch(){
        this.props.waiting.handleShow('Buscando...');
        fetch(Config.default.apiGateway.URL+'offers/check?offer_id='+this.state.no_offer+'&option='+(this.state.interview_type === 'interview' ? 'questionnaire' : 'self_exclusion'),{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(async response => {
            if(response !== undefined){
                await this.clear();
                
                await this.setState({
                    id:response.id,
                    name:response.donor_name,
                    date: moment(response.timestamp_date).format('DD/MM/YYYY')+' '+moment(response.timestamp_hour, 'HH:mm:ss.sssssss').format('HH:mm:ss')
                })

                swal({
                    title: "Alerta",
                    text: "Eres "+response.donor_name+"?",
                    type: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Si",
                    cancelButtonText: "No"
                    //customClass: "Custom_Cancel"
                }, async (isConfirm)=> {
                    if (isConfirm) {
                        this.getQuestions();
                        
                        if(this.state.exclusion_by_questionnaire.value === 'YES' && this.state.interview_type === 'autoexclusion'){
                            this.getMessage();
                        }
                    }else{
                        await this.clear();
                        await this.setState({interview_type: this.state.exclusion_by_questionnaire.value === 'YES' ? 'autoexclusion' : "interview"});
                    }
                });

                
            }
        })
    }

    getQuestions(){
        fetch(Config.default.apiGateway.URL+'questionaries/by_center/'+sessionStorage.getItem('health_facilities_id'),{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(async response => {
            if(response !== undefined){
                var table = [];

                response.questions.forEach((question)=>{
                    var obj = {
                        ask_id:question.ask_id,
                        title: question.description,
                        columns:[],
                        rows:[],
                        required:false,
                    };

                    if(question.type === 'AGRUPADA'){
                        obj.columns = [{title:""}];
                    }

                    question.blocks.forEach((block, i)=>{
                        var row = {
                            block_id: question.type === 'SIMPLE' ? "" : block.block_id,
                            label: question.type === 'SIMPLE' ? "" : block.label,                            
                            sections:[]
                        };

                        question.sections.forEach((section)=>{
                            var item = {
                                section_id: section.section_id,
                                sections:[],
                                value:"",
                                type:section.type
                            };
                            
                            if(section.section_options.length > 0){
                                section.section_options.forEach((option)=>{
                                    item.sections.push({
                                        value: option.value,
                                        label: option.label,
                                        checked:false
                                    });
                                });
                            }else{                                
                                item.value = "";
                                item.min_value = section.min_value;
                                item.max_value = section.max_value;
                            }

                            row.sections.push(item);
                        });

                        obj.rows.push(row);
                    });

                    if(question.blocks.length === 0){
                        var row = {
                            block_id: "",
                            label: "",
                            sections:[]
                        };

                        question.sections.forEach((section)=>{
                            var item = {
                                section_id: section.section_id,
                                sections:[],
                                value:"",
                                type:section.type
                            };
                            
                            if(section.section_options.length > 0){
                                section.section_options.forEach((option)=>{
                                    item.sections.push({
                                        value: option.value,
                                        label: option.label,
                                        checked:false
                                    });
                                });
                            }else{                                
                                item.value = "";
                                item.min_value = section.min_value;
                                item.max_value = section.max_value;
                                item.label = section.subtitle;
                            }

                            row.sections.push(item);
                        });

                        obj.rows.push(row);
                       
                    }

                    question.sections.forEach((section, i)=>{ 
                        if(section.section_options.length > 0){
                            section.section_options.forEach((option)=>{                                
                                if(question.type === 'AGRUPADA'){
                                    obj.columns.push({
                                        title:option.label
                                    });
                                }
                            });
                        }else{
                            if(question.type === 'AGRUPADA'){
                                obj.columns.push({
                                    title:section.subtitle
                                });
                            }
                        }
                    });

                    table.push(obj);
                })                
                
                if(this.state.exclusion_by_questionnaire.value === 'YES' && this.state.interview_type === 'autoexclusion'){
                    table.unshift({
                        ask_id: 'self_exclusion',
                        title: '¿CONSIDERA QUE SU SANGRE ES SEGURA?',
                        columns:[],
                        rows:[{                            
                            sections:[{
                                section_id: "",
                                sections:[
                                    {label:'SI, MI SANGRE ES SEGURA', value:'NO', checked:false},
                                    {label:'NO, MI SANGRE NO ES SEGURA', value:'YES', checked:false}
                                ],
                                value:"",
                            }]                            
                        }],
                        required:true,
                    });
                }
                await this.setState({questions: table, questionary_id:response.id});

                if(this.state.disable){
                    //await this.getResponse();
                }
                
            }
        })
    }

    getResponse(){
        fetch(Config.default.apiGateway.URL+'offer_questionnaire?offer_id='+this.state.id,{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                    this.setState({disable:false});
                });
            }
        }).then(response => {
            if(response !== undefined){
                var questions = this.state.questions;
                questions.map((q)=>{
                    
                    if(q.id === 'self_exclusion'){
                        q.value = response.self_exclusion === null ? '' 
                                : response.self_exclusion ? 'YES' : 'NO';
                        
                        q.options.map((option)=>{
                            if(option.value === q.value){
                                option.checked = true;
                            }
                        })
                    }else{
                        var index = response.questionnaire_response.findIndex(obj => obj.ask_id === q.id);
                        
                        if(index !== -1){                        
                            q.value = response.questionnaire_response[index].answer;

                            q.options.map((option)=>{
                                if(option.value === q.value){
                                    option.checked = true;
                                }
                            })
                            
                        }
                    }
                })

                this.setState({
                    questions: questions,
                    date_response: moment(response.timestamp).format('DD/MM/YYYY HH:mm:ss')
                })
            }
        })
    }

    onSave(e){
        this.setState({focusedInput:false})
        e.preventDefault();
        var url = '';
        var obj = {};
        var valid = false;
        var error = '';
        var index = -1;

        if(this.state.interview_type === 'autoexclusion'){
            url = 'self_exclusion/by_questionnaire';
            obj = {
                offer_id: this.state.id,
                answer: this.state.self_exclusion
            };
            valid = true;
            if(this.state.self_exclusion === ""){
                valid = false;
            }
        }else{
            url = 'offer_questionnaire';
            obj = {
                questionary_id: this.state.questionary_id,
                offer_id: this.state.id,
                questionnaire_response:[]
            };
            
            valid = true;
            this.state.questions.map((q, i)=>{            
                if(q.ask_id !== 'self_exclusion'){
                    var question = {
                        ask_id: q.ask_id,
                        responses:[]
                    };

                    q.rows.map((row, j)=>{
                        
                        row.sections.map((item)=>{
                            item.sections.map((section)=>{                                
                                if(section.checked){
                                    question.responses.push({
                                        section_id: item.section_id,
                                        value: item.value,
                                        block_id:row.block_id
                                    });
                                }


                            })

                            if(item.sections.length === 0){
                                question.responses.push({
                                    section_id: item.section_id,
                                    value: item.value,
                                    block_id:row.block_id
                                });
                            }
                        });
                    });

                    if(question.responses.length === 0){
                        valid = false;
                    }
                    obj.questionnaire_response.push(question);

                }                
            });  

            if(obj.questionnaire_response.length === 0){
                error = 'error';
            }
        }       

        if(valid){
            if(error === ''){
                this.props.waiting.handleShow('Guardando...');
                fetch(Config.default.apiGateway.URL+url,{
                    method:'POST',
                    body:JSON.stringify(obj),
                    headers: new Headers({
                        'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'        : 'application/json',
                        'Content-Type'  : 'application/json'
                    })
                }).then(res => {
                    this.props.waiting.handleClose();
                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg) => {
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(response => {
                    if(response !== undefined){
                        swal('Correcto', 'Los datos se guardaron correctamente', 'success');
                        this.clear();
                        this.setState({interview_type:''});
                    }
                })
            }else{
                swal('Error', 'Debe contestar por lo menos una pregunta', 'error');
            }
        }else{
            swal('Error', 'La pregunta '+(index+1)+' debe ser contestada', 'error');
        }
    }

    isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    var vacio = false;

	    inputs.forEach(input => {
            if(input.required){
                const isInputValid = this.showCtrlError(input.id);
             
                if (!isInputValid) {                    
                    vacio = true;
                }
            }
	    });

	    if(vacio){
	    	isFormValid = false;
	    }

	    return isFormValid;
    }

    showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

        if(control !== null){
            if(control.required){
                if(control.value === ""){
                    control.classList.add('error');
                    res = false;
                    
                }else{
                    if(control.className.includes('error')){
                        control.classList.remove('error');
                        
                    }
                    res = true;
                }

            }
        }
		
		return res;		
	}
    
    clear(){
        this.setState({
            no_offer:"",
            id:"",
            date:"",
            questions:[],
            questionary_id:"",
            date_response:"",
            index:0,
            name:"",            
        });
    }

    onLast(){
        if(this.state.index > 0){
            this.setState({
                index: this.state.index - 1
            });
        }
    }

    onNext(){
        if(!this.validQuestion(this.state.index)){
            if(this.state.index < this.state.questions.length - 1){
                console.log(this.state.index+1);
                if (this.state.index+1 ==7||this.state.index+1==9) {
                        this.setState({focusedInput:false})                    
                }
                this.setState({
                    index: this.state.index + 1
                });
            }
        }else{
            swal('Error', 'La pregunta debe ser contestada', 'error');
        }
        
    }

    validQuestion(index){
        var questions = this.state.questions;        
        var valid = true;
        var cont = 0;

        questions[index].rows.map((row)=>{            
            if(row.sections !== undefined){
                
                row.sections.map((item)=>{                    
                    item.sections.map((section)=>{                            
                        if(section.checked){
                            cont++;
                        }
                    });
    
                    if(item.sections.length === 0 && row.sections.length === 1){
                        valid = false;
                    }
                    
                });

                var selection = row.sections.findIndex(obj => obj.type === 'SELECTION');
                
                if(selection !== -1){
                    if(cont === questions[index].rows.length){
                        valid = false;
                    }
                }else{
                    if(cont === questions[index].rows.length){
                        valid = false;
                    }
                }

            }else{                
                valid = false;
            }
        });

    

        return valid;
    
    }
    startRead = ()=>{
		try{
			console.log("inciando...");
			this.props.socket.send("FPReset");
			this.props.socket.send('get');
			this.setState({flagStart:true});
		}catch(error){
			swal("Error", "Lector de huella no identificado", 'error');
		}
	}
    handleInputBlur = () => {
        this.setState({ focusedInput: null, });
      }
      handleButtonClick = (value) => {
        if (this.state.fieldName==='12-0-0-'||this.state.fieldName==='8-0-0-'||this.state.fieldName==='11-0-0-') {
            if (value === '<--') {
                for (const elemento of document.getElementsByName(this.state.fieldName)) {
                    elemento.value= elemento.value.slice(0,-1);
                    console.log(elemento.value);
                  } 
            }else{
            for (const elemento of document.getElementsByName(this.state.fieldName.toString())) {
                elemento.value +=value;
                console.log(elemento);
              }}
        }
        
        //console.log(this.state.questions);
        
        //document.getElementsByName('12-0-0-').value+=value;
        //console.log(pregunta);
        // const { focusedInput } = this.state;
        // if (focusedInput === 'input1') {
        //   this.setState({ input1Text: this.state.input1Text + value });
        // } else if (focusedInput === 'input2') {
        //   this.setState({ input2Text: this.state.input2Text + value });
        // }
      }
      handleInputFocus = (index,fieldName) => {
        console.log(fieldName);
        if (fieldName ==='12-0-0-'||fieldName ==='8-0-0-'||fieldName==='11-0-0-') {
            this.setState({focusedInput:true,fieldName:fieldName})
            if (fieldName==='11-0-0-') {
                for (const elemento of document.getElementsByName(fieldName)) {
                    elemento.value="";
                    console.log(elemento);
                  }
            }
        }else{
            this.setState({focusedInput:false})
        }
        //this.setState({ indexHelper:index,fieldName: fieldName });
      }
      handleToggleKeyboard = () => {
        this.setState((prevState) => ({
          isKeyboardVisible: !prevState.isKeyboardVisible,
        }));
      };
    render(){
        const {t} = this.props;
        const { isKeyboardVisible } = this.state;
        return(
            <div className="col-xs-12">
                <div className="route">
                    <h5 className="title_page" >
                        {session} ->
                        {t('sidebar.nav.donors.MAIN')} -> 
                        Encuesta
                    </h5>
                </div>

                <Help
                    {...this.props}
                    menu={"help_donors"} 
                    submenu={"help_offers_questionary"}  />
                
                <div className="col-xs-12">
                    {(this.state.exclusion_by_questionnaire.value === 'YES' && this.state.interview_type === '') &&
                        <div className="col-xs-12" style={{textAlign:'center', marginTop:'10%'}}>
                            <button style={{fontSize:25, height:'100px'}} className="btn btn-info"
                                onClick={()=>this.setState({interview_type:'autoexclusion'})}
                            >Autoexclusión</button>
                            <button style={{fontSize:25, height:'100px', marginLeft:8}} className="btn btn-info"
                                onClick={()=>this.setState({interview_type:'interview'})}
                            >Encuesta de Calidad</button>
                        </div>
                    }
                    {this.state.interview_type !== "" &&
                        <div className="col-xs-12">
                            {this.state.searchByOffer &&
                            <div className="col-xs-12 col-sm-8 col-md-4">
                                <div className="col-xs-12">
                                    <span className="span-min" style={{fontSize:25}}>Número de ofrecimiento</span>
                                </div>
                                <div className="col-xs-12">
                                    <div className="col-xs-12 col-sm-7" style={{padding:0}}>
                                        <input type="number" className="form-control input-sm hour-input" 
                                            name="no_offer" id="no_offer" value={this.state.no_offer} 
                                            onChange={(e)=>this.handleChange(e)}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-1" style={{marginTop:-3, fontSize:20}}>
                                        <button className="btn btn-info" onClick={()=>this.onSearch()}>Buscar</button>
                                    </div>        
                                </div>   
                                <div className="col-xs-12 col-sm-1" style={{marginTop:-3, fontSize:20}}>
                                        <button className="btn btn-info" onClick={()=>this.ChangeSearchByFingerprint()}>Buscar por huella</button>
                                    </div>                          
                            </div>  
                            } 
                            <div></div>
                            {this.state.searchByFingerprint &&
                            <div>
                                <div className="row">
		        		<div className="col-xs-12">
		        			{this.state.flagStart?
		        				<div>
		        					{!this.state.flagFinished?
										<div>
					        				<label>COLOQUE SU HUELLA</label>
				        				</div>
			        				:<div>
			        					{this.state.searching?
			        						<div>
		        							<label>BUSCANDO COINCIDENCIAS</label>
			        							<div style={{textAlign:'center'}}>
			        								<Loader 
			        									type="Oval" 
			        									color="#64b5f6" 
			        									height={80} 
			        									width={80}
			        									/> 
			        							</div>
			        						</div>
			        						:
                                            <div className="col-xs-12 col-sm-1 mb-2" style={{marginTop:-3, fontSize:20}}>
                                                <label>NO SE ENCONTRÓ NINGUNA COINCIDENCIA</label>
                                        <button className="btn btn-info" onClick={()=>this.ChangeSearchByFingerprint()}>Intentar de nuevo</button>
                                    </div>
			        					}	
			        				</div>}

		        				</div>
		        			:null}
		        			{!this.state.flagFinished&&!this.state.flagStart?
                            <div className="col-xs-12 col-sm-7 mb-2" style={{marginTop:-3, fontSize:20}}>
                                <RaisedButton label="Iniciar Lectura" primary={true} onClick={this.startRead} style={{float:"right"}} disabled={this.state.disableStartBtn}/>
                            </div>
			        		:null}
			        	</div>
				        </div>
                            <div className="col-xs-12 col-sm-1" style={{marginTop:-3, fontSize:20}}>
                            <button className="btn btn-info" onClick={()=>this.ChangeSearchByOffer()}>Buscar por ofrecimiento</button>
                        </div> 
                        </div>
                            }                         
                        </div>

                    }
                    {this.state.id !== "" &&
                        <div className="col-xs-12 questions-data">
                            <hr />
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-3">
                                    <span className="span-min" style={{fontSize:25}}>Id:</span>
                                </div>
                                <div className="col-xs-12 col-sm-9">
                                    <span>{this.state.id}</span>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-3">
                                    <span className="span-min" style={{fontSize:25}}>Nombre:</span>
                                </div>
                                <div className="col-xs-12 col-sm-9">
                                    <span>{this.state.name}</span>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-3">
                                    <span className="span-min" style={{fontSize:25}}>Fecha:</span>
                                </div>
                                <div className="col-xs-12 col-sm-9">
                                    <span>{this.state.date}</span>
                                </div>
                            </div>
                            {this.state.disable &&
                                <div className="col-xs-12">
                                    <div className="col-xs-12 col-sm-3">
                                        <span className="span-min" style={{fontSize:25}}>Respondido el:</span>
                                    </div>
                                    <div className="col-xs-12 col-sm-9">
                                        <span>{this.state.date_response}</span>
                                    </div>
                                </div>
                            }
                            
                        </div>
                    }                    

                    {this.state.questions.length > 0 &&
                        <form className="col-xs-12">
                            <hr/>
                            <div className="col-xs-12 form-group">
                                <fieldset style={{padding:8}}>
                                    <legend className="question-section">
                                        {this.state.exclusion_by_questionnaire.value === 'YES' ?
                                            this.state.index === 0 ? 'AUTOEXCLUSIÓN' : 'ENCUESTA'
                                        : 'ENCUESTA'}
                                    </legend>
                                    {this.state.questions[this.state.index] !== undefined &&
                                        <div className="col-xs-12 form-group question-data">
                                            <Table responsive hover>
                                                <caption style={{fontSize:'25px', textAlign:'center'}}>
                                                    {this.state.questions[this.state.index].title}
                                                </caption>
                                                <thead>
                                                    <tr>
                                                        {this.state.questions[this.state.index].columns.map((col, i)=>
                                                            <th key={i} style={{textAlign:'center '}}>
                                                                {col.title}
                                                            </th>  
                                                        )}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.questions[this.state.index].columns.length === 0 ?                                                        
                                                        this.state.questions[this.state.index].rows.map((row, i)=>                                                            
                                                            row.sections.map((item, j)=>
                                                                item.sections.length > 0 ?
                                                                    <tr key={j}>
                                                                        {item.sections.map((section, k)=>
                                                                            <td key={k}>
                                                                                <div onChange={(e)=>this.changeRadio(e)} className="col-xs-12" style={{fontSize:'20px', textAlign:'center'}}>
                                                                                    <input 
                                                                                        type="checkbox" 
                                                                                        checked={section.checked} 
                                                                                        value={section.value} 
                                                                                        name={this.state.questions[this.state.index].ask_id+'-'+i+'-'+j+'-'+k}
                                                                                        style={{
                                                                                            width:'100%',
                                                                                            height:20
                                                                                        }}
                                                                                    />
                                                                                    <span style={{display:'block'}}>{section.label}</span>
                                                                                </div>
                                                                            </td>
                                                                        )}
                                                                    </tr>
                                                                : 
                                                                    <tr key={j}>
                                                                        <td colSpan={j > 0 ? row.sections[j - 1].sections.length : 1}>
                                                                            {item.type === 'OPEN' || item.type === 'DATE' || item.type === 'RANGE' || item.type === 'NUMBER' ?
                                                                                <div className={
                                                                                    item.type === 'DATE' ?
                                                                                        "col-xs-12 col-sm-4"
                                                                                    : "col-xs-12"
                                                                                }>
                                                                                    <span style={{display:'block', fontSize:20, marginTop:5}}>{item.label}</span>
                                                                                    <input
                                                                                        type={item.type === 'OPEN' ?
                                                                                            'text'
                                                                                        : item.type === 'RANGE' ?
                                                                                            'range'
                                                                                        : item.type === 'DATE' ?
                                                                                            'date'
                                                                                        :
                                                                                            'number'
                                                                                        }
                                                                                        min={item.type === 'RANGE' ?
                                                                                            item.min_value
                                                                                        : ""
                                                                                        }
                                                                                        max={item.type === 'RANGE' ?
                                                                                            item.max_value
                                                                                        : ""
                                                                                        }
                                                                                        className="form-control" 
                                                                                        style={{resize:'none', fontSize:20}}
                                                                                        value={row.value}
                                                                                        onChange={(e)=>this.changeRadio(e)}
                                                                                        name={this.state.questions[this.state.index].ask_id+'-'+i+'-'+j+'-'}
                                                                                        onFocus= {item.type=='OPEN'?() => this.handleInputFocus(this.state.questions[this.state.index],this.state.questions[this.state.index].ask_id+'-'+i+'-'+j+'-'):null}
                                                                                 //onBlur={item.type=='OPEN'?this.handleInputBlur:null}
                                                                                    />
                                                                                    
                                                                                </div>
                                                                            :
                                                                                <textarea 
                                                                                    className="form-control" 
                                                                                    style={{resize:'none', fontSize:20}}
                                                                                    rows={5}
                                                                                    value={item.value}
                                                                                    onChange={(e)=>this.changeRadio(e)}
                                                                                    name={this.state.questions[this.state.index].ask_id+'-'+i+'--'}
                                                                                ></textarea>
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                            )
                                                        )                                                        
                                                    :
                                                        this.state.questions[this.state.index].rows.map((row, i)=>
                                                            <tr key={i}>
                                                                <td>{row.label}</td>
                                                                {row.sections.map((item, j)=>
                                                                    item.sections.length > 0 ?
                                                                        item.sections.map((section, k)=>
                                                                            <td key={k}>                                                                        
                                                                                <div onChange={(e)=>this.changeRadio(e)} className="col-xs-12" 
                                                                                    style={{fontSize:'20px', textAlign:'center'}}
                                                                                >
                                                                                    <input 
                                                                                        type="checkbox" 
                                                                                        checked={section.checked} 
                                                                                        value={section.value} 
                                                                                        name={this.state.questions[this.state.index].ask_id+'-'+i+'-'+j+'-'+k}
                                                                                        style={{
                                                                                            width:'100%',
                                                                                            height:20
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        )
                                                                            
                                                                    :                                                                         
                                                                        <td key={j}>                                                                            
                                                                            <input
                                                                                type={item.type === 'OPEN' ?
                                                                                    'text'
                                                                                : item.type === 'RANGE' ?
                                                                                    'range'
                                                                                : item.type === 'DATE' ?
                                                                                    'date'
                                                                                :
                                                                                    'number'
                                                                                }
                                                                                min={item.type === 'RANGE' ?
                                                                                    item.min_value
                                                                                : ""
                                                                                }
                                                                                max={item.type === 'RANGE' ?
                                                                                    item.max_value
                                                                                : ""
                                                                                }
                                                                                className="form-control" 
                                                                                style={{resize:'none', fontSize:20}}
                                                                                value={item.value}
                                                                                onChange={(e)=>this.changeRadio(e)}
                                                                                name={this.state.questions[this.state.index].ask_id+'-'+i+'-'+j+'-'}
                                                                            />
                                                                            
                                                                        </td>
                                                                )}
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </Table>
                                            {this.state.focusedInput && (
                                               
                                            <VirtualKeyboard onButtonClick={this.handleButtonClick}
                                            onCloseKeyboard={this.handleToggleKeyboard} />
                                            
        )}
                                        </div>
                                    }
                                    {(this.state.index < this.state.questions.length - 1 && this.state.interview_type === 'interview') &&
                                        <div className="col-xs-12" style={{textAlign:'center'}}>
                                            {/*this.state.index > 0 && 
                                                <Button style={{fontSize:20}} onClick={()=>this.onLast()}>Anterior</Button>
                                            */}
                                            {this.state.questions[this.state.index] !== undefined ?
                                                //this.state.questions[this.state.index].rows.length === 0 ?
                                                    <Button onClick={()=>this.onNext()} style={{marginLeft:8, fontSize:20}}>Siguiente</Button>
                                                //:null
                                            : null}
                                        </div>
                                    }                                    
                                </fieldset>
                            </div>
                            {(this.state.index === this.state.questions.length - 1 || this.state.interview_type === 'autoexclusion') && 
                                <div className="col-xs-12" style={{textAlign:'center'}}>
                                    <button className="btn btn-info" style={{fontSize:20}} onClick={(e)=>this.onSave(e)}>Guardar</button>
                                </div>
                            }
                        </form>
                    }

                </div>
            </div>
        )
    }
    
}

export default translate('translations')(Interview);